import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import Login from '@/views/Login.vue'
import Dashboard from '@/views/Dashboard.vue'
import Home from '@/views/dashboard/Home.vue'

Vue.use(Router)

const constantRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: Dashboard,
    name: 'Dashboard',
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: { title: '首页', icon: 'el-icon-s-home', permission: 'home' }
      }
    ]
  },
//   { path: '*', redirect: '/login' }
]

const router = new Router({
  mode: 'history',
  routes: constantRoutes
})

export function resetRouter() {
  const newRouter = new Router({
    mode: 'history',
    routes: constantRoutes
  })
  router.matcher = newRouter.matcher
  store.commit('permission/SET_MENU_LIST', [])
}

//设置白名单,不需要登录就能看的路由
const whiteList = ["/login"];
// 路由守卫：只做 token 校验和重定向，不做动态路由添加
router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('access_token')
    if(token){
        if (to.path == "/" || to.path == "/login") {
            next({ path: "/home" });
        }else{
            next()
        }
    }else {
        if (whiteList.indexOf(to.path) !== -1) {
            //判断是否存在于白名单中
            next();
        } else {
            next({ path: "/login" }); //不存在白名单中
        }
    }

})

export default router